import * as React from 'react';
import Box from '@mui/material/Box';
import { Checkbox, Divider } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import Wrapper from '../components/Wrapper/Wrapper';
import classes from './FilterDescriptors.module.css';
import { Helmet } from 'react-helmet';
import popisy_db from "../popisy.json";
import VideoTextContainer from '../components/VideoTextContainer/VideoTextContainer';
import { getUrlArrayFromChapter } from '../utils/utils';
import { useSearchParams } from 'react-router-dom';

const CheckboxGroup = Checkbox.Group;

const popisyUrovenOptions = ['A1', 'A2', 'B1', 'B2'];
const popisyKapitolaOptions = ['GRAMATICKÉ MINIMUM', 'SOCIOKULTURNÍ ZNALOSTI'];
const popisyOkruhyOptions = ['JÁ A MOJE RODINA', 'DŮM, DOMÁCNOST A NEJBLIŽŠÍ OKOLÍ', 'KAŽDODENNÍ ŽIVOT', 'VOLNÝ ČAS A ZÁBAVA', 'CESTOVÁNÍ A DOPRAVA', 'VZTAHY MEZI LIDMI', 'ZDRAVÍ A PÉČE O TĚLO', 'VZDĚLÁNÍ A VZDĚLÁVÁNÍ', 'OBCHODY A NAKUPOVÁNÍ', 'JÍDLO A PITÍ', 'INSTITUCE A SLUŽBY', 'JAZYK A KOMUNIKACE', 'POPIS CESTY A MÍSTA', 'POČASÍ A KLIMA'];

const FilterPopisy = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [popisyCheckedList, setPopisyCheckedList] = React.useState<CheckboxValueType[]>(searchParams.getAll('popisy-uroven'));
  const [popisyCheckedList1, setPopisyCheckedList1] = React.useState<CheckboxValueType[]>(searchParams.getAll('popisy-kapitola'));
  const [popisyCheckedList2, setPopisyCheckedList2] = React.useState<CheckboxValueType[]>(searchParams.getAll('popisy-okruh'));

  React.useEffect(() => {
    setSearchParams({
      "popisy-uroven": popisyCheckedList as string[],
      "popisy-kapitola": popisyCheckedList1 as string[],
      "popisy-okruh": popisyCheckedList2 as string[],
    });
  }, [
    setSearchParams,
    popisyCheckedList,
    popisyCheckedList1,
    popisyCheckedList2,
  ]);

  // console.log(popisyCheckedList)
  // console.log(popisyCheckedList1)
  // console.log(popisyCheckedList2)

  const [popisyIndeterminate, setPopisyIndeterminate] = React.useState(true);
  const [popisyIndeterminate1, setPopisyIndeterminate1] = React.useState(true);
  const [popisyIndeterminate2, setPopisyIndeterminate2] = React.useState(true);

  const [checkAllPopisy, setCheckAllPopisy] = React.useState(false);
  const [checkAllPopisy1, setCheckAllPopisy1] = React.useState(false);
  const [checkAllPopisy2, setCheckAllPopisy2] = React.useState(false);

  const [displayedContent, setDisplayedContent] = React.useState<TableInterface[]>([])

  let filterPopisy = { uroven: [], kapitola: [], okruh: [] };

  const onPopisyChange = (list: CheckboxValueType[]) => {
    setPopisyCheckedList(list);
    setPopisyIndeterminate(!!list.length && list.length < popisyUrovenOptions.length);
    setCheckAllPopisy(list.length === popisyUrovenOptions.length);
  };

  const onPopisyChange1 = (list: CheckboxValueType[]) => {
    setPopisyCheckedList1(list);
    setPopisyIndeterminate1(!!list.length && list.length < popisyKapitolaOptions.length);
    setCheckAllPopisy1(list.length === popisyKapitolaOptions.length + popisyOkruhyOptions.length + 1);
  };

  const onPopisyChange2 = (list: CheckboxValueType[]) => {
    setPopisyCheckedList2(list);
    setPopisyIndeterminate2(!!list.length && list.length < popisyOkruhyOptions.length);
    setCheckAllPopisy1(list.length === popisyOkruhyOptions.length + popisyKapitolaOptions.length + 1);
  };

  const onCheckAllPopisyChange = (e: CheckboxChangeEvent) => {
    setPopisyCheckedList(e.target.checked ? popisyUrovenOptions : []);
    setPopisyIndeterminate(false);
    setCheckAllPopisy(e.target.checked);
  };

  const onCheckAllPopisyChange1 = (e: CheckboxChangeEvent) => {
    setPopisyCheckedList1(e.target.checked ? popisyKapitolaOptions : []);
    setPopisyCheckedList2(e.target.checked ? popisyOkruhyOptions : []);
    setPopisyIndeterminate1(false);
    setPopisyIndeterminate2(false);
    setCheckAllPopisy1(e.target.checked);
    setCheckAllPopisy2(e.target.checked);
  };

  const onCheckAllPopisyChange2 = (e: CheckboxChangeEvent) => {
    setPopisyCheckedList2(e.target.checked ? popisyOkruhyOptions : []);
    setPopisyIndeterminate1(false);
    setCheckAllPopisy2(e.target.checked);
  };

  const [url, setUrl] = React.useState("");
  const [playing, setPlaying] = React.useState(false);
  const [urlIndex, setUrlIndex] = React.useState(0);
  const [urlArray, setUrlArray] = React.useState<Array<string>>([]);

  /*  on submit section */
  /* this should be cached */

  const allTabesFromChapter = (chapter: any) => {
    return chapter.pars
      .filter((c: any) => {
        return c.type === "popisy-table-2";
      })
      .concat(
        chapter.children.reduce((result: any, current: any) => {
          return result.concat(allTabesFromChapter(current));
        }, [])
      );
  };

  const arrayOfRRZJTables = (database: any) => {
    // console.log(database, 'databaze')
    return database.map((chapter: any) => {
      // console.log(allTabesFromChapter(chapter));
      return allTabesFromChapter(chapter);
    }).flat();
  };

  interface PopisyInterface {
    uroven: string[];
    kapitola: string[];
    okruh: string[];
  }

  interface TableInterface {
    headline: string;
    rows: {
      description: {
        content: string;
        url: string;
      };
      czj: {
        content: string;
        url: string;
      };
      cj: {
        content: string;
        url: string;
      }
    }[];
  }


  const onSubmitPopisy = ({ uroven, kapitola, okruh }: PopisyInterface) => {
    // const tables = arrayOfRRZJTables(popisy_db) as TableInterface[];

    // console.log('haha', tables)

    // const res = tables
    //   .map((t) => {
    //     const filteredRows = t.rows.filter((row) => {
    //       return row.level.tags.every(
    //         (tag) =>
    //           uroven.includes(tag) ||
    //           kapitola.includes(tag) ||
    //           okruh.includes(tag) ||
    //           (uroven.length === 0 && popisyUrovenOptions.includes(tag)) ||
    //           (kapitola.length === 0 &&
    //             popisyKapitolaOptions.includes(tag)) ||
    //             (okruh.length === 0 && popisyOkruhyOptions.includes(tag))
    //         //   ||
    //         // (uroven.length === 0 && rrzjUrovenOptions.includes(tag)) ||
    //         // (stupnice.length === 0 && rrzjStupniceOptions.includes(tag))
    //       );
    //     });

    //     console.log(res)

    //     return { ...t, rows: filteredRows };
    //   })
    //   .filter((t) => t.rows.length !== 0);

    // setDisplayedContent(res);
    // setUrlArray(getUrlArrayFromChapter([{
    //   headline: "",
    //   headline_url: "",
    //   video_code: "",
    //   number: "",
    //   slug: "",
    //   references: [],
    //   pars: res,
    //   children: []
    // }]).slice(1))
  };

  const onParagraphClick = (url: string) => {
    if (url.length === 0 || url.slice(0, 7) === "NOMATCH") {
      return;
    }

    setUrl(url || ""); /* Set a placeholder instead */
    setPlaying(true);

    /* update URL index when user clicks on a paragraph */
    const foundIndex = urlArray.findIndex((i: string) => i === url);

    if (foundIndex === -1) {
      setUrlIndex(0);
    } else {
      setUrlIndex(foundIndex);
    }
  };

  return (
    <Wrapper background="rgb(240, 240, 240)">
      <Helmet>
        <title>Vyhledávání</title>
      </Helmet>
      <Breadcrumbs />
      <h2 className={classes.headingTop}>Vyhledávání v popisech</h2>
      <div>
        <div style={{ display: "flex" }}>
          <div className={classes.checkboxWrapper}>
            <div className={classes.checkboxContainerPopisy}>
              <div className={classes.checkboxHeader}>Podle úrovně</div>
              <Box sx={{ width: "100%" }}>
                <CheckboxGroup
                  style={{ display: "flex", flexDirection: "column" }}
                  options={popisyUrovenOptions}
                  value={popisyCheckedList}
                  onChange={onPopisyChange}
                />
                <Divider />
                <Checkbox
                  indeterminate={popisyIndeterminate}
                  onChange={onCheckAllPopisyChange}
                  checked={checkAllPopisy}
                >
                  Vybrat vše
                </Checkbox>
              </Box>
            </div>
            <div className={classes.checkboxContainerPopisy}>
              <div className={classes.checkboxHeader}>Podle kapitoly</div>

              <Box sx={{ width: "100%" }}>
                <CheckboxGroup
                  style={{ display: "flex", flexDirection: "column" }}
                  options={popisyKapitolaOptions}
                  value={popisyCheckedList1}
                  onChange={onPopisyChange1}
                />
                <Divider />
                <div style={{ fontWeight: "600" }}>TÉMATICKÉ OKRUHY:</div>
                <Checkbox
                  style={{ paddingLeft: "20px" }}
                  indeterminate={popisyIndeterminate2}
                  onChange={onCheckAllPopisyChange2}
                  checked={checkAllPopisy2}
                >
                  VŠECHNY
                </Checkbox>
                <CheckboxGroup
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingLeft: "20px",
                  }}
                  options={popisyOkruhyOptions}
                  value={popisyCheckedList2}
                  onChange={onPopisyChange2}
                />
                <Divider />
                <Checkbox
                  indeterminate={popisyIndeterminate1}
                  onChange={onCheckAllPopisyChange1}
                  checked={checkAllPopisy1}
                >
                  Vybrat vše
                </Checkbox>
              </Box>
            </div>
          </div>
        </div>
        <div className={classes.buttonWrapper}>
          <button
            className={classes.button}
            onClick={() => {
              const checklist2 =
                popisyCheckedList1.concat(popisyCheckedList2);
              filterPopisy.uroven = popisyCheckedList as never;
              filterPopisy.kapitola = checklist2 as never;
              onSubmitPopisy(filterPopisy);
            }}
          >
            Zobrazit výsledky
          </button>
        </div>
      </div>

      {displayedContent.length !== 0 && (
        <div style={{ marginTop: "2rem" }}>
          <VideoTextContainer
            chapterContent={[
              {
                headline: "",
                headline_url: "",
                video_code: "",
                number: "",
                slug: "",
                references: [],
                pars: displayedContent,
                children: []
              },
            ]}
            url={url}
            onParagraphClick={onParagraphClick}
            noVideo={false}
            urlArray={urlArray}
            urlIndex={urlIndex}
            setUrlIndex={setUrlIndex}
            playing={playing}
            setPlaying={setPlaying}
            setUrl={setUrl}
            foldableTables
          />
        </div>
      )}
    </Wrapper>
  );
}

export default FilterPopisy;
